import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ActionsBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { sizing } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/sizing";
import {
  ContentProp,
  DesignProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultButtonState } from "../../../ModifiedStyleAttributes/buttonStates";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Button",
  version: 1,
  nameI18n: "builder_ui.block_type.button",
  category: [ActionsBlock],
  props: {
    text: {
      name: "Text",
      nameI18n: "builder_ui.prop_type.text",
      category: [ContentProp],
      prop: "other",
      type: "rich-text",
    },
    href: {
      name: "Link",
      nameI18n: "builder_ui.prop_type.link",
      category: [ContentProp],
      prop: "other",
      type: "string",
    },
    buttonType: {
      name: "Button Type",
      nameI18n: "builder_ui.prop_type.button_type",
      category: [DesignProp],
      prop: "other",
      type: "select",
      defaultValue: "primaryButton",
      options: [
        {
          label: "Primary",
          labelI18n: "builder_ui.prop_type.button_type.primary",
          value: "primaryButton",
        },
        {
          label: "Secondary",
          labelI18n: "builder_ui.prop_type.button_type.secondary",
          value: "secondaryButton",
        },
        {
          label: "Custom",
          labelI18n: "builder_ui.prop_type.button_type.custom",
          value: "customButton",
        },
      ],
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles",
      category: [DesignProp],
      prop: "custom",
      type: "button",
      attributes: {
        ...defaultButtonState,
        alignment: {
          ...defaultButtonState.defaultValue.alignment,
          defaultValue: defaultStyles.alignment,
        },
        backgroundColor: {
          ...defaultButtonState.defaultValue.backgroundColor,
          defaultValue: defaultStyles.backgroundColor,
        },
        borderColor: {
          ...defaultButtonState.defaultValue.borderColor,
          defaultValue: defaultStyles.borderColor,
        },
        borderRadius: {
          ...defaultButtonState.defaultValue.borderRadius,
          defaultValue: defaultStyles.borderRadius,
        },
        borderWidth: {
          ...defaultButtonState.defaultValue.borderWidth,
          defaultValue: defaultStyles.borderWidth,
        },
        color: {
          ...defaultButtonState.defaultValue.color,
          defaultValue: defaultStyles.color,
        },
        fontSize: {
          ...defaultButtonState.defaultValue.fontSize,
          defaultValue: defaultStyles.fontSize,
        },
        fontStyle: {
          ...defaultButtonState.defaultValue.fontStyle,
          defaultValue: defaultStyles.fontStyle,
        },
        fontWeight: {
          ...defaultButtonState.defaultValue.fontWeight,
          defaultValue: defaultStyles.fontWeight,
        },
        lineHeight: {
          ...defaultButtonState.defaultValue.lineHeight,
          defaultValue: defaultStyles.lineHeight,
        },
        textAlign: {
          ...defaultButtonState.defaultValue.textAlign,
          defaultValue: defaultStyles.textAlign,
        },
        textDecoration: {
          ...defaultButtonState.defaultValue.textDecoration,
          defaultValue: defaultStyles.textDecoration,
        },
        textTransform: {
          ...defaultButtonState.defaultValue.textTransform,
          defaultValue: defaultStyles.textTransform,
        },
        sizing: {
          ...sizing,
          defaultValue: defaultStyles.sizing,
        },
        margin: {
          ...margin,
          defaultValue: defaultStyles.margin,
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
        },
      },
    },
  },
};
